export default class StringUtil {
    public static enclose(s: string, prefix: string, postfix: string, ignoreEmpty: boolean = true) {
        if (ignoreEmpty && (s || "") === "") {
            return s;
        }
        return `${prefix}${s}${postfix}`;
    }
}